import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import moment from 'moment'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
    Avatar,
    Box,
    Card,
    Chip,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    Modal,
    TableRow,
    Typography,
    makeStyles,
    CircularProgress,
    IconButton
} from '@material-ui/core'
import {
    RemoveCircleOutlineRounded,
    DoneRounded,
    Visibility
} from '@material-ui/icons'
import getInitials from '../../../utils/getInitials'
import firebase from 'firebase/app'
import PostCard from '../../../components/PostCard'
import EventCard from '../../../components/EventCard'
import UserCard from '../../../components/UserCard'
import CommentCard from '../../../components/CommentCard'
import ChatCard from '../../../components/ChatCard'

const useStyles = makeStyles((theme) => ({
    root: {},
    avatar: {
        marginRight: theme.spacing(2)
    },
    itemCard: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        maxHeight: '80%',
        maxWidth: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        overflowY: 'auto',
        boxShadow: theme.shadows[5]
    }
}))

const Results = (props) => {
    const {
        className,
        reports,
        setReports,
        page,
        filter,
        setPage,
        limit,
        setLimit,
        // appendNewUsers,
        // noMoreData,
        ...rest
    } = props
    const classes = useStyles()
    const [selectedCustomerIds, setSelectedCustomerIds] = useState([])
    const [shownUsers, setShownUsers] = useState()
    const [postModalOpen, setPostModalOpen] = useState(false)
    const [selectedItem, setSelectedItem] = useState()

    function handleClose() {
        setPostModalOpen(false)
    }

    useEffect(() => {
        if (selectedItem && postModalOpen) {
            let itemRef
            switch (selectedItem.dataType) {
                case 'chat':
                    itemRef = firebase
                        .firestore()
                        .doc(`chats/${selectedItem.data.id}`)
                    break
                case 'comment':
                    if (selectedItem.data.type === 'post') {
                        itemRef = firebase
                            .firestore()
                            .doc(
                                `posts/${selectedItem.data.postId}/comments/${selectedItem.data.id}`
                            )
                    } else if (selectedItem.data.type === 'event') {
                        itemRef = firebase
                            .firestore()
                            .doc(
                                `events/${selectedItem.data.postId}/comments/${selectedItem.data.id}`
                            )
                    }
                    break
                case 'event':
                    itemRef = firebase
                        .firestore()
                        .doc(`events/${selectedItem.data.id}`)
                    break
                case 'post':
                    itemRef = firebase
                        .firestore()
                        .doc(`posts/${selectedItem.data.id}`)
                    break
                case 'user':
                    itemRef = firebase
                        .firestore()
                        .doc(`users/${selectedItem.data.id}`)
                    break
                default:
                    return
            }

            const unsubscribe = itemRef.onSnapshot((doc) => {
                if (doc.exists) {
                    const _data = doc.data()

                    setSelectedItem({
                        ...selectedItem,
                        data: { ..._data, id: doc.id }
                    })
                }
            })
            // .then(() => console.log(selectedItem.dataType, 'SUCCEEDD'))
            // .catch((e) => console.log('ERROR', e))

            return () => unsubscribe()
        }
    }, [postModalOpen])

    useEffect(() => {
        const _shownUsers = reports
            .slice(0 + limit * page, limit * (page + 1))
            .map((user) => user.id)

        setShownUsers(_shownUsers)
    }, [limit, page, reports])

    const handleSelectAll = (event) => {
        let newSelectedCustomerIds

        if (event.target.checked) {
            newSelectedCustomerIds = reports
                .slice(0 + limit * page, limit * (page + 1))
                .map((user) => user.id)
        } else {
            newSelectedCustomerIds = []
        }

        setSelectedCustomerIds(newSelectedCustomerIds)
    }

    const handleSelectOne = (event, id) => {
        const selectedIndex = selectedCustomerIds.indexOf(id)
        let newSelectedCustomerIds = []

        if (selectedIndex === -1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds,
                id
            )
        } else if (selectedIndex === 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(1)
            )
        } else if (selectedIndex === selectedCustomerIds.length - 1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(0, -1)
            )
        } else if (selectedIndex > 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedCustomerIds.slice(0, selectedIndex),
                selectedCustomerIds.slice(selectedIndex + 1)
            )
        }

        setSelectedCustomerIds(newSelectedCustomerIds)
    }

    const handleLimitChange = (event) => {
        setLimit(event.target.value)
        if (event.target.value * page > reports.length) {
            const _newPage = Math.floor(reports.length / event.target.value)
            setPage(_newPage)
        }
    }

    const handlePageChange = (event, newPage) => {
        setPage(newPage)
    }

    async function updateIssue(report) {
        return firebase
            .firestore()
            .doc(`reports/${report.id}`)
            .update({
                status: report.status === 'done' ? 'pending' : 'done'
            })
            .catch((e) => console.log('Error', e))
            .then(() => {
                if (filter === 'all') {
                    const updatedReports = reports.map((data) => {
                        if (data.id === report.id) {
                            return {
                                ...data,
                                status:
                                    report.status === 'done'
                                        ? 'pending'
                                        : 'done'
                            }
                        } else return data
                    })
                    setReports(updatedReports)
                } else {
                    const updatedReports = reports.filter(
                        (data) => data.id !== report.id
                    )
                    setReports(updatedReports)
                }
            })
    }

    if (reports.length < 1) {
        return (
            <Card className={clsx(classes.root, className)} {...rest}>
                <PerfectScrollbar>
                    <Box
                        display="flex"
                        minWidth={1050}
                        minHeight={200}
                        justifyItems="center"
                        alignItems="center"
                    >
                        <h2>There is no reports yet.</h2>
                    </Box>
                </PerfectScrollbar>
            </Card>
        )
    }

    return (
        <>
            <Card className={clsx(classes.root, className)} {...rest}>
                <PerfectScrollbar>
                    <Box minWidth={1050}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            checked={
                                                JSON.stringify(
                                                    selectedCustomerIds
                                                ) === JSON.stringify(shownUsers)
                                            }
                                            color="primary"
                                            indeterminate={false}
                                            onChange={handleSelectAll}
                                        />
                                    </TableCell>
                                    <TableCell>Creator</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Tag</TableCell>
                                    <TableCell>Data Type</TableCell>
                                    <TableCell>Report Date</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reports
                                    .slice(0 + limit * page, limit * (page + 1))
                                    .map((report) => (
                                        <TableRow
                                            hover
                                            key={report.id}
                                            selected={selectedCustomerIds.includes(
                                                report.id
                                            )}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    checked={selectedCustomerIds.includes(
                                                        report.id
                                                    )}
                                                    onChange={(event) =>
                                                        handleSelectOne(
                                                            event,
                                                            report.id
                                                        )
                                                    }
                                                    value="true"
                                                />
                                            </TableCell>

                                            <TableCell>
                                                <Box
                                                    alignItems="center"
                                                    display="flex"
                                                >
                                                    <Avatar
                                                        className={
                                                            classes.avatar
                                                        }
                                                        src={report.photoURL}
                                                    >
                                                        {getInitials(
                                                            report.name
                                                        )}
                                                    </Avatar>
                                                    <Typography
                                                        color="textPrimary"
                                                        variant="body1"
                                                    >
                                                        {report.name}
                                                        {'  '}
                                                        {report.surname}
                                                    </Typography>
                                                </Box>
                                            </TableCell>

                                            <TableCell>
                                                <Chip
                                                    color={
                                                        report.status === 'done'
                                                            ? 'primary'
                                                            : 'default'
                                                    }
                                                    label={
                                                        report.status
                                                            ? report.status
                                                            : 'pending'
                                                    }
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    style={{
                                                        backgroundColor:
                                                            'turquoise'
                                                    }}
                                                    label={report.tag}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    style={{
                                                        backgroundColor:
                                                            'lightyellow'
                                                    }}
                                                    label={report.dataType}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {moment(
                                                    report.createDate?.toDate()
                                                ).format('HH:mm, DD/MM/YYYY')}
                                            </TableCell>

                                            <TableCell>
                                                <IconButton
                                                    title="View"
                                                    onClick={() => {
                                                        setSelectedItem(report)
                                                        setPostModalOpen(true)
                                                    }}
                                                >
                                                    <Visibility />
                                                </IconButton>
                                                <IconButton
                                                    title={
                                                        report.status === 'done'
                                                            ? 'Open Issue'
                                                            : 'Close Issue'
                                                    }
                                                    onClick={() =>
                                                        updateIssue(report)
                                                    }
                                                >
                                                    {report.status !==
                                                    'done' ? (
                                                        <DoneRounded
                                                            color={'green'}
                                                        />
                                                    ) : (
                                                        <RemoveCircleOutlineRounded />
                                                    )}
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </Box>
                </PerfectScrollbar>
                <TablePagination
                    component="div"
                    count={reports.length}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleLimitChange}
                    page={page}
                    rowsPerPage={limit}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </Card>
            <Modal
                // disableBackdropClick={!!loading}
                open={postModalOpen}
                onClose={handleClose}
                aria-labelledby="selected-post-modal"
                aria-describedby="selected-post-modal-description"
            >
                <>
                    {selectedItem?.dataType === 'event' ? (
                        <EventCard
                            className={classes.itemCard}
                            event={selectedItem.data}
                            list={reports}
                            setEvents={setReports}
                        />
                    ) : selectedItem?.dataType === 'post' ? (
                        <PostCard
                            className={classes.itemCard}
                            post={selectedItem.data}
                            list={reports}
                            setPosts={setReports}
                        />
                    ) : selectedItem?.dataType === 'user' ? (
                        <UserCard
                            className={classes.itemCard}
                            user={selectedItem.data}
                            list={reports}
                            setUsers={setReports}
                        />
                    ) : selectedItem?.dataType === 'comment' ? (
                        <CommentCard
                            className={classes.itemCard}
                            comment={selectedItem.data}
                        />
                    ) : selectedItem?.dataType === 'chat' ? (
                        <ChatCard
                            className={classes.itemCard}
                            chat={selectedItem.data}
                        />
                    ) : (
                        <CircularProgress />
                    )}
                </>
            </Modal>
        </>
    )
}

Results.propTypes = {
    className: PropTypes.string,
    reports: PropTypes.array.isRequired,
    limit: PropTypes.number,
    setLimit: PropTypes.func,
    page: PropTypes.number,
    setPage: PropTypes.func,
    setReports: PropTypes.func,
    filter: PropTypes.string
}

// Results.propTypes = {
//   className: PropTypes.string,
//   reports: PropTypes.array.isRequired
// };

export default Results
